export default __webpack_public_path__ + "static/Servicio Marítimo-7a2bec4c386cc921bc425b4e86917da8.svg";